'use client';

import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';

import { ListingItemType } from '@/slw/entities/home/home.model';
import { formatCurrency } from '@/slw/shared/lib/format-number';

interface ProductItemProps {
  item: ListingItemType;
}

export function ProductItem({ item }: ProductItemProps) {
  const [imgUrl, setUrlImg] = useState<string>(item.mainImageUrl);

  useEffect(() => {
    setUrlImg(item.mainImageUrl);
  }, [item.mainImageUrl]);

  const renderLocation = () => {
    let location = '';

    if (item.stateName && !item.countryName) {
      location = item.stateName;
    }

    if (!item.stateName && item.countryName) {
      location = item.countryName;
    }

    if (item.stateName && item.countryName) {
      location = `${item.stateName}, ${item.countryName}`;
    }

    return location;
  };

  return (
    <div
      className='product-item bg-sidebar rounded-[8px] p-2 mb-4 md:mb-5
    hover:[&_img]:transform-[scale(1.2)]'
    >
      <div className='rounded-[6px] overflow-hidden'>
        <div className='w-full aspect-[16/9] relative'>
          <Link href={`/listing/${item.url}`}>
            <Image
              className='rounded-[6px] w-full transition-all duration-300 object-cover object-center'
              src={imgUrl}
              alt=''
              fill
              onError={() => setUrlImg('/images/common/no-image-available.png')}
            />
          </Link>
        </div>
      </div>
      <div className='p-2'>
        <Link href={`/listing/${item.url}`} className='block font-bold mt-2'>
          {item.subTitle}
        </Link>
        <div className='model mt-1 text-[0.875rem]'>{renderLocation()}</div>
        <div className='mt-1 text-primary text-[1.125rem] font-bold text-right'>{formatCurrency(item.price)}</div>
      </div>
    </div>
  );
}
